import React, { useState } from 'react';
import CategoryList from '../components/settings/CategoryList';
import { useLanguage } from '../contexts/LanguageContext';
import CommonPageHeader from '../components/common/CommonPageHeader';
import { TagIcon, PlusIcon } from '@heroicons/react/24/outline';

const Categories = () => {
  const { t } = useLanguage();
  const [shouldOpenForm, setShouldOpenForm] = useState(false);
  const [displayMode, setDisplayMode] = useState<'table' | 'card'>('card');

  const handleNewClick = () => {
    setShouldOpenForm(true);
  };

  const handleFormOpened = () => {
    setShouldOpenForm(false);
  };

  return (
    <div className="space-y-4 pb-20 sm:pb-6">
      <CommonPageHeader
        title={t('settings.categories.title')}
        subtitle={t('settings.categories.subtitle') || 'Kategóriák kezelése és szervezése'}
        icon={TagIcon}
      >
        <div className="flex items-center bg-white/10 backdrop-blur-sm rounded-lg p-1">
          <button
            onClick={() => setDisplayMode('table')}
            className={`flex items-center px-3 py-1.5 rounded-md transition-all text-xs ${displayMode === 'table'
              ? 'bg-white/30 text-white font-medium'
              : 'text-white/70 hover:text-white'}`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M3 14h18M3 18h18M3 6h18" />
            </svg>
            <span className="hidden sm:inline">Táblázat</span>
          </button>
          <button
            onClick={() => setDisplayMode('card')}
            className={`flex items-center px-3 py-1.5 rounded-md transition-all text-xs ${displayMode === 'card'
              ? 'bg-white/30 text-white font-medium'
              : 'text-white/70 hover:text-white'}`}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
            </svg>
            <span className="hidden sm:inline">Kártyák</span>
          </button>
        </div>
        <button
          onClick={handleNewClick}
          className="bg-white/20 backdrop-blur-sm text-white px-3 py-2 rounded-md text-sm flex items-center justify-center hover:bg-white/30 transition-colors"
        >
          <PlusIcon className="h-4 w-4 mr-2" />
          <span>{t('settings.categories.add')}</span>
        </button>
      </CommonPageHeader>
      <CategoryList
        triggerNewForm={shouldOpenForm}
        onFormOpened={handleFormOpened}
        displayMode={displayMode}
      />
    </div>
  );
};

export default Categories;